import { useEffect } from 'react';
// @mui
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
//
import { DateTime } from 'luxon';
// components
import { useDispatch, useSelector } from '../../../redux/store';
//
import { useLocales } from '../../../locales';
import Chart from '../../../components/chart/chart';
import { useChart } from '../../../components/chart';
import { fNumber, fShortenNumber } from '../../../utils/format-number';
import { IInsightTableFilters } from '../../../types/insight';
import { getEstimatedMemberLeg } from '../../../redux/slices/insight';

// ----------------------------------------------------------------------

export default function EstimatedLengthOfEngagementView({
  fromDate,
  toDate,
  membershipTypeIds,
  minimumLengthOfMembershipInDays,
}: IInsightTableFilters) {
  const { t } = useLocales();

  const dispatch = useDispatch();

  const report = useSelector((state) => state.insight.estimatedMemberLeg);

  useEffect(() => {
    dispatch(
      getEstimatedMemberLeg({
        fromDate,
        toDate,
        membershipTypeIds,
        minimumLengthOfMembershipInDays,
      })
    );
  }, [dispatch, fromDate, toDate, membershipTypeIds, minimumLengthOfMembershipInDays]);

  const chart = {
    series:
      report.series?.map((p) => ({
        name: p.name,
        data:
          p.data?.map((d: any) => ({
            x: d.x,
            y: d.y,
          })) ?? [],
      })) ?? [],
  };

  const chartOptions = useChart({
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    xaxis: {
      labels: {
        formatter: (value) => DateTime.fromISO(value).toFormat('MMM yyyy'),
      },
    },
    dataLabels: {
      formatter: (val, opts) => fNumber(val as number),
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: (value) => `${fShortenNumber(value)}`,
      },
    },
  });

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <CardHeader
        title={t('Estimated LEG')}
        subheader={t(
          'Shows length of engangement based on a calculation of churn rather than actual length of engagement in months'
        )}
        action={<> </>}
      />
      <CardContent>
        <Chart dir="ltr" type="area" series={chart.series} options={chartOptions} />
      </CardContent>
    </Card>
  );
}
